import React from 'react';
import ReactMarkdown from 'react-markdown';
import '../styles/proposal-viewer.css';
import '../styles/pdf-export.css';

const ProposalViewer = ({ proposal, onClose, onDownloadPdf }) => {
  if (!proposal) return null;
  
  // Format the proposal for better display using our helper function
  const formattedProposal = proposal
    .replace(/\\n/g, '\n') // Fix newlines
    .replace(/\|\s*\|/g, '|   |') // Add space in empty table cells
    .replace(/!\[Fox River AI Logo\]\([^)]*\)/g, ''); // Remove the logo reference
  
  return (
    <div className="proposal-viewer">
      <div className="proposal-content">
        <button className="close-proposal" onClick={onClose}>×</button>
        <div className="proposal-header">
          <img src="/Fox-logo-1.png" alt="Relufox AI Logo" className="proposal-logo" />
          <h2>Complete Project Proposal</h2>
        </div>
        <div className="markdown-content">
          <ReactMarkdown>{formattedProposal}</ReactMarkdown>
        </div>
        <div className="proposal-actions">
          <button className="download-button" onClick={onDownloadPdf}>
            Download as PDF
          </button>
          <button className="close-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProposalViewer;